import styled from 'styled-components';

export const CheckBoxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0;
  width: 24px;
  height: 24px;
`;

export const CheckBoxInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 24px;
  height: 24px;
  opacity: 0;
  cursor: pointer;
`;
